<template>
  <v-row align="center" class="driverNavigation" style="fontSize: 14px;">
    <v-flex pr-2>
      <p style="fontWeight: 500; ">{{driver.user.name}}</p>
    </v-flex>
    <v-flex pr-2>
      <p>
        <a :href="'mailto:' + driver.user.email">{{ driver.user.email }}</a>
      </p>
    </v-flex>
    <v-flex pr-2>
      <p>
        <a
          :href="'tel:' + formatNumber(driver.user.contact_number) "
        >{{ driver.user.contact_number }}</a>
      </p>
    </v-flex>
  </v-row>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "driver_search_box",
  components: {},
  props: {
    driver: Object,
    picture: String,
    taxi: Object
  },
  data: function() {
    return {
      showResetPassword: false
    };
  },
  methods: {
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
